import { render, staticRenderFns } from "./CustomerOrderForm.vue?vue&type=template&id=06b75e54"
import script from "./CustomerOrderForm.vue?vue&type=script&lang=ts"
export * from "./CustomerOrderForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b75e54')) {
      api.createRecord('06b75e54', component.options)
    } else {
      api.reload('06b75e54', component.options)
    }
    module.hot.accept("./CustomerOrderForm.vue?vue&type=template&id=06b75e54", function () {
      api.rerender('06b75e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/CustomerOrderForm.vue"
export default component.exports